import Card from 'react-bootstrap/Card';
import logofoot from '../assets/Images/logo-foot.png';
import React from 'react';

import { useState } from "react";


function BlogCard(props) {

  const cardClassName = 'rounded-4 cardBackground cardBlog border-0  ';
  // const cardNameClassName = props.CardName ? `card-name-${props.CardName.toLowerCase().replace(/\s/g, '-')}` : '';
  const [description, setDescription] = useState(false);
  const combinedClassName = `${cardClassName}  ${props.className}`;

  function appear() {
    setDescription(true);
  }
  function disappear() {
    setDescription(false);
  }

  return (

    <Card onMouseOver={appear} onMouseOut={disappear} style={{
      color: '#FBF3E4', width: '25.5rem',
      height: 'fit-content',
      boxShadow: '0 3px 15px  rgba(0, 0, 0, 0.5) ',
      // rgb(51 51 51 / 64%) 0px -90px 30px -20px inset
    }} className={combinedClassName} >
      <Card.Header className={'bg-transparent  border-0'}>
        <img src={logofoot} width={'10%'} style={{ marginLeft: '90%' }} />
      </Card.Header>
      <Card.Body style={{ transition: 'all  0.3s ease', marginBottom: description ? '30px' : null }} >
        <h5 className=' line-normal2 fourem '>{props.Title}</h5 >
        {/*<Card.Subtitle className="mb-2 text-muted">Card Subtitle</Card.Subtitle>*/}
        <Card.Text className={'mt-4 fs-6 mb-4'}>
          {props.text}
        </Card.Text>

      </Card.Body>
    </Card>
  );
}

export default BlogCard;